module.exports = __webpack_public_path__ + "static/media/Shopify.9277ead1.jpeg";